import React, { useEffect, useRef, useState } from 'react';
import { buildHeroScene, supportsWebGL } from '../../utils/heroScene';
interface LeadershipSculptureProps {
  fallbackSrc: string;
}
type RenderMode = 'loading' | 'webgl' | 'fallback';
export function LeadershipSculpture({
  fallbackSrc
}: LeadershipSculptureProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [mode, setMode] = useState<RenderMode>('loading');
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (!supportsWebGL()) {
      setMode('fallback');
      return;
    }
    let cancelled = false;
    let cleanup: (() => void) | null = null;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    Promise.all([import('three'), import('three/examples/jsm/environments/RoomEnvironment.js')]).then(([THREE, environment]) => {
      if (cancelled) return;
      try {
        cleanup = buildHeroScene(THREE, environment.RoomEnvironment, container, reduceMotion);
        setMode('webgl');
      } catch {
        setMode('fallback');
      }
    }).catch(() => {
      if (!cancelled) setMode('fallback');
    });
    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, []);
  return <div className="relative h-full w-full" aria-hidden="true" data-id="element-459" data-mp="q3yn1ds6uhg8">
      {mode === 'fallback' && <img src={fallbackSrc} alt="" loading="lazy" className="h-full w-full object-contain" data-id="element-460" data-mp="m24rtl0ri5ng" />}
      <div ref={containerRef} className={`absolute inset-0 transition-opacity duration-300 ease-out ${mode === 'webgl' ? 'opacity-100' : 'opacity-0'}`} data-id="element-461" data-mp="hbemg7sc62sr" />
    </div>;
}